module.exports = __webpack_public_path__ + "static/media/opposition-0.d53eee0a.png";